import { logError } from '../tracing';
const _defaultCookieConsent = {
    name: 'cookiesConsent',
    exists: false,
    firstParty: false,
    thirdParty: false,
    marketingParty: false,
    showBanner: true,
    expirationDays: 180, // 6 mesi
};

const getDefaultCookieConsentValues = () => _defaultCookieConsent;

const _getCookieConsent = () => {
    const name = _defaultCookieConsent.name;
    return decodeURIComponent(
        document.cookie.replace(
            new RegExp(
                '(?:(?:^|.*;)\\s*' +
                    encodeURIComponent(name).replace(/[\-\.\+\*]/g, '\\$&') +
                    '\\s*\\=\\s*([^;]*).*$)|^.*$'
            ),
            '$1'
        )
    );
};

const existsCookieConsent = () => _getCookieConsent() || null;

const _removeCookies = (cookieNames) => {
    //Works only for cookie without "httponly" attribute
    if (!cookieNames || cookieNames.length === 0) return;
    for (var i = 0; i < cookieNames.length; i++) {
        var cookie = cookieNames[i];
        if (existsCookieConsent(cookie.name))
            document.cookie = btoa(
                `${encodeURIComponent(
                    cookie.name
                )}=; expires=Thu, 01 Jan 1970 00:00:00 GMT${
                    cookie.domain ? '; domain=' + cookie.domain : ''
                }; path=/`
            );
    }
};

const removeCookieConsent = () =>
    _removeCookies([{ name: _defaultCookieConsent.name }]);

const cookiesEnabled = () => {
    //navigator.cookieEnabled proved to be not reliable at all
    return (
        'cookie' in document &&
        (document.cookie.length > 0 ||
            (document.cookie = 'test').indexOf.call(document.cookie, 'test') >
                -1)
    );
};

const _setCookieConsent = ({
    name,
    showBanner,
    firstParty,
    thirdParty,
    marketingParty,
}) => {
    /*jshint validthis:true */
    const cookieName =
        !name || /^(?:expires|max\-age|path|domain|secure)$/i.test(name)
            ? _defaultCookieConsent.name
            : name;

    var expires = '';
    var date = new Date();
    date.setTime(
        date.getTime() +
            _defaultCookieConsent.expirationDays * 24 * 60 * 60 * 1000
    );
    expires = '; expires=' + date.toUTCString();

    // NOTA: properties pascalCase per deserializzazione lato server!!
    var value = JSON.stringify({
        FirstParty: firstParty, // NOTA: properties pascalCase per deserializzazione lato server!!
        ThirdParty: thirdParty, // NOTA: properties pascalCase per deserializzazione lato server!!
        MarketingParty: marketingParty, // NOTA: properties pascalCase per deserializzazione lato server!!
        ShowBanner: showBanner, // NOTA: properties pascalCase per deserializzazione lato server!!
    });
    document.cookie =
        `${encodeURIComponent(cookieName)}=` +
        btoa(`${value}`) +
        `${expires}; path=/`;
    return true;
};

const acceptAllAndDontShowBanner = () =>
    _setCookieConsent({
        showBanner: false,
        firstParty: true,
        thirdParty: true,
        marketingParty: true,
    });

const getDecodedCookieConsentValues = () => {
    try {
        const cookie = _getCookieConsent();
        var asciiVal = atob(cookie);
        let values = JSON.parse(asciiVal);
        return values;
    } catch (error) {
        console.error(
            'getDecodedCookieValues: Cannot decode or parse cookie ',
            error
        );
        return null;
    }
};

const setCookieConsent = ({
    showBanner,
    firstParty,
    thirdParty,
    marketingParty,
}) => _setCookieConsent({ showBanner, firstParty, thirdParty, marketingParty });

const getMarketingParty = () => {
    const cookieConsentValues = getDecodedCookieConsentValues();
    let partyConsent =
        cookieConsentValues === null ||
        cookieConsentValues === undefined ||
        cookieConsentValues.MarketingParty === null ||
        cookieConsentValues.MarketingParty === undefined
            ? false
            : cookieConsentValues.MarketingParty === true;
    return partyConsent;
};

const getThirdParty = () => {
    const cookieConsentValues = getDecodedCookieConsentValues();
    let partyConsent =
        cookieConsentValues === null ||
        cookieConsentValues === undefined ||
        cookieConsentValues.ThirdParty === null ||
        cookieConsentValues.ThirdParty === undefined
            ? false
            : cookieConsentValues.ThirdParty === true;
    return partyConsent;
};

const _getCookie = function (cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

const getUserProfileOptions = () => {
    const userProfileCookieKey = 'userProfile';
    try {
        const cookie = _getCookie(userProfileCookieKey);
        if (cookie) {
            const parsedCookie = JSON.parse(atob(cookie));
            return {
                countryCode: parsedCookie.CountryCode,
                currencyCode: parsedCookie.CurrencyCode,
                name: parsedCookie.Name,
            };
        }
        throw new Error(
            `Cookie ${userProfileCookieKey} not found, falling back to defaults`
        );
    } catch (error) {
        logError(`Error decoding cookie ${userProfileCookieKey}`, error);
        return {
            countryCode: 'ITA',
            currencyCode: 'EUR',
            name: userProfileCookieKey,
        };
    }
};

export default {
    getDefaultCookieConsentValues,
    removeCookieConsent,
    existsCookieConsent,
    cookiesEnabled,
    acceptAllAndDontShowBanner,
    getDecodedCookieConsentValues,
    setCookieConsent,
    getMarketingParty,
    getThirdParty,
    getUserProfileOptions,
};
